/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// Takes a credit card string value and returns true on valid number
const luhnValidateCreditCard = (cardNumber) => {
    let value = cardNumber;
    // Accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm.
    let nCheck = 0;
    let bEven = false;
    value = value.replace(/\D/g, '');
    let n = value.length - 1;

    for (n; n >= 0; n -= 1) {
        const cDigit = value.charAt(n);
        let nDigit = parseInt(cDigit, 10);

        if (bEven) {
            nDigit *= 2;
            if (nDigit > 9) {
                nDigit -= 9;
            }
        }
        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) === 0;
};

export default luhnValidateCreditCard;
